import { Pipe, PipeTransform } from '@angular/core';
import {AnyObject, CardStructureConfig, ItemAttrListDataSet, ItemIconRender} from '@mri/types';

@Pipe({
  name: 'cardItemIconRender'
})
export class CardItenIconRenderPipe implements PipeTransform {

  transform(date: AnyObject, prop: ItemAttrListDataSet, structure: CardStructureConfig<AnyObject>): ItemIconRender | undefined {
    if (typeof structure.icon === 'function')
      return structure.icon(prop);

    return undefined;
  }

}
